<mat-card class="card-style px-6 py-6 pt-0 h-full">
<!--  <mat-card-header class="flex justify-between items-center">-->
<!--    <mat-card-title class=""-->
<!--      >{{item.ativo == 'S' ? 'Desativar' : 'Ativar' }} tipo tarifário</mat-card-title-->
<!--    >-->
<!--    <button class="btn-icon" (click)="close()">-->
<!--      <mat-icon>close</mat-icon>-->
<!--    </button>-->
<!--  </mat-card-header>-->
  <div class="mt-5 container mx-auto">
      <div class="flex flex-col gap-2 mt-4 mb-2">
        <div class="text-lg text-center">
          <strong>{{item.ativo == 'S' ? 'Desativando' : 'Ativando' }}</strong> trecho:
          <strong>{{item.descricao }}</strong>?
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="flex flex-col items-center gap-4">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
  </div>
</mat-card>
